import React from 'react';
import './Services.scss';
import { useLanguage } from "../LanguageContext";
import { useNavigate } from "react-router-dom";
import Benefits from '../components/Benefits/Benefits';

const Services = () => {
  const navigate = useNavigate();
  const { t } = useLanguage(); // 👈 translation function
  return (

    <div>
      <Benefits/>
      
    </div>
  );
};

export default Services;